import React from "react";
import { useNavigate } from "react-router-dom";
import "./TopGameGrid.css";

const TOP_GAMES = [
  "17906784088622973.gif",
  "17721764783098752.gif",
  "17814456767483963.gif",
  "17721765018272496.gif",
  "17721764078548857.gif",
  "17721764146044131.gif",
  "17753849476434381.gif",
  "17721764215895316.gif",
];

const TopGameGrid = () => {
  const navigate = useNavigate();
  return (
    <section className="top-game-grid" aria-label="Featured games">
      {TOP_GAMES.map((imageName) => (
        <button
          key={imageName}
          type="button"
          className="top-game-grid-card"
          onClick={() => navigate("/dashboard?view=casino")}
        >
          <img
            src={`${process.env.PUBLIC_URL}/Images/Top_images/${imageName}`}
            alt=""
            loading="lazy"
          />
        </button>
      ))}
    </section>
  );
};

export default TopGameGrid;
